var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineViewOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.566 42l37.5-36M17.928 38.102c1.966.61 4.014.914 6.072.898 8.2.138 16.516-5.626 21.648-11.274a3.325 3.325 0 000-4.452A41.158 41.158 0 0039.5 17.76M28.826 12.564A19.141 19.141 0 0024 12c-8.062-.134-16.4 5.504-21.642 11.27a3.325 3.325 0 000 4.452 41.754 41.754 0 005.2 4.8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 25.5a7.497 7.497 0 017.496-7.5H24M31.5 25.498h0A7.5 7.5 0 0124.002 33H24",
    strokeWidth: 3
  }))));
}
export default SvgStreamlineViewOff;